
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galleries/[id]/artworks/[artwork]",
      function () {
        return require("private-next-pages/galleries/[id]/artworks/[artwork].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/galleries/[id]/artworks/[artwork]"])
      });
    }
  